module.exports = __webpack_public_path__ + "img/modalRecapSvg.23c2aaf4.svg";